import {cn} from '../../lib/utils';
import {Input} from '../shadcn/input';

import type {ChangeEvent, ClipboardEvent, KeyboardEvent} from 'react';

export interface OtpCodeBoxProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  onPaste: (e: ClipboardEvent<HTMLInputElement>) => void;
  error?: boolean;
  disabled?: boolean;
  inputRef: (el: HTMLInputElement | null) => void;
}

/** Single digit box backing OtpCodeField. */
export function OtpCodeBox({
  value,
  onChange,
  onKeyDown,
  onPaste,
  error,
  disabled,
  inputRef
}: OtpCodeBoxProps) {
  return (
    <Input
      ref={inputRef}
      data-slot="otp-code-box"
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      aria-invalid={error || undefined}
      disabled={disabled}
      inputMode="numeric"
      maxLength={1}
      dir="ltr"
      className={cn(
        'h-16 flex-1 rounded-lg border-border bg-background-surface px-0 text-center font-display text-display-sm font-semibold text-fg shadow-xs',
        error && 'bg-background-error'
      )}
    />
  );
}
